export const priceListData = {
  description1:
    "W moim życiu czerpałam z wiedzy wielu specjalistów, co miało istotny wpływ na moje zawodowe i osobiste ukształtowanie. Jako fizjoterapeuta od początku kariery jestem związana z gabinetem Fizjo-Factory, a także pracuję niezależnie. Moje doświadczenie trenerskie obejmuje liczne boxy CrossFit, gdzie prowadziłam zarówno zajęcia grupowe, jak i indywidualne, zdobywając bogate doświadczenie w dziedzinie treningów.",
  description2:
    "Obecnie pracuję jako trener indywidualny w ZdroFit. Prowadzę klientów przez proces diagnostyki, terapii manualnej oraz treningów, dostosowując je do indywidualnych potrzeb oraz grupowych celów.",
  prices: [
    "Fizjoterapia od 200zł",
    "Wizyta z USG od 270zł",
    "Pojedynczy trening 1na1 - 250zł",
    "8 treningów 1na1 - 1800zł",
    "12 treningów 1na1 - 2580zł",
    "Pakiet hybrydowy, 4 spotkania od 940zł. Do wykorzystania 4 spotkania w ciągu 2 miesięcy. W zależności od potrzeby może to być trening, terapia manualna, wizyta z usg. Termin kolejnych spotkań ustalamy mailowo bądź na pierwszym treningu.",
  ],
};
